import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from './getFilters';

export const getFilterLocation = createSelector(getFilters, state => state.location);
